"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MessageAdList_1 = require("./components/MessageAdList");
exports.MessageAdList = MessageAdList_1.default;
//# sourceMappingURL=lazyIndex.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-messagead-list-view/lib/lazyIndex.js
// module id = 2580
// module chunks = 67